"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSendingParams = exports.CHAIN_EIP1559_SET = exports.PriceRoundingType = exports.PointRoundingType = exports.getChain = exports.initialChainTable = exports.ChainId = void 0;
var ChainId;
(function (ChainId) {
    ChainId[ChainId["None"] = -1] = "None";
    // mainnet
    ChainId[ChainId["EthereumMainnet"] = 1] = "EthereumMainnet";
    ChainId[ChainId["Optimism"] = 10] = "Optimism";
    ChainId[ChainId["ZkSyncEra"] = 324] = "ZkSyncEra";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["ETC"] = 61] = "ETC";
    ChainId[ChainId["Aurora"] = 1313161554] = "Aurora";
    ChainId[ChainId["Matic"] = 137] = "Matic";
    ChainId[ChainId["Arbitrum"] = 42161] = "Arbitrum";
    ChainId[ChainId["Cronos"] = 25] = "Cronos";
    ChainId[ChainId["Icplaza"] = 142857] = "Icplaza";
    ChainId[ChainId["ConfluxESpace"] = 1030] = "ConfluxESpace";
    ChainId[ChainId["Meter"] = 82] = "Meter";
    ChainId[ChainId["Telos"] = 40] = "Telos";
    ChainId[ChainId["Ontology"] = 58] = "Ontology";
    ChainId[ChainId["Ultron"] = 1231] = "Ultron";
    ChainId[ChainId["Mantle"] = 5000] = "Mantle";
    ChainId[ChainId["Base"] = 8453] = "Base";
    ChainId[ChainId["Linea"] = 59144] = "Linea";
    ChainId[ChainId["Loot"] = 5151706] = "Loot";
    ChainId[ChainId["OpBNB"] = 204] = "OpBNB";
    ChainId[ChainId["Kroma"] = 255] = "Kroma";
    ChainId[ChainId["Manta"] = 169] = "Manta";
    ChainId[ChainId["Scroll"] = 534352] = "Scroll";
    ChainId[ChainId["ZKFair"] = 42766] = "ZKFair";
    ChainId[ChainId["Zeta"] = 7000] = "Zeta";
    ChainId[ChainId["Merlin"] = 4200] = "Merlin";
    ChainId[ChainId["Blast"] = 81457] = "Blast";
    ChainId[ChainId["ZklinkNova"] = 810180] = "ZklinkNova";
    ChainId[ChainId["Mode"] = 34443] = "Mode";
    ChainId[ChainId["AINNL2"] = 2649] = "AINNL2";
    ChainId[ChainId["XLayer"] = 196] = "XLayer";
    ChainId[ChainId["BOB"] = 60808] = "BOB";
    ChainId[ChainId["Cyber"] = 7560] = "Cyber";
    ChainId[ChainId["Taiko"] = 167000] = "Taiko";
    ChainId[ChainId["Klaytn"] = 8217] = "Klaytn";
    ChainId[ChainId["Kava"] = 2222] = "Kava";
    ChainId[ChainId["Core"] = 1116] = "Core";
    ChainId[ChainId["RootStock"] = 30] = "RootStock";
    ChainId[ChainId["MAP"] = 22776] = "MAP";
    ChainId[ChainId["NEON"] = 245022934] = "NEON";
    ChainId[ChainId["Gravity"] = 1625] = "Gravity";
    ChainId[ChainId["Iotex"] = 4689] = "Iotex";
    ChainId[ChainId["Flow"] = 747] = "Flow";
    ChainId[ChainId["Morph"] = 2818] = "Morph";
    ChainId[ChainId["Plume"] = 98865] = "Plume";
    ChainId[ChainId["Duckchain"] = 5545] = "Duckchain";
    ChainId[ChainId["HashKey"] = 177] = "HashKey";
    // testnet
    ChainId[ChainId["Rinkeby"] = 4] = "Rinkeby";
    ChainId[ChainId["Goerli"] = 5] = "Goerli";
    ChainId[ChainId["BSCTestnet"] = 97] = "BSCTestnet";
    ChainId[ChainId["OntologyTestnet"] = 5851] = "OntologyTestnet";
    ChainId[ChainId["MaticTestnet"] = 80001] = "MaticTestnet";
    ChainId[ChainId["AuroraTestnet"] = 1313161555] = "AuroraTestnet";
    ChainId[ChainId["ZkSyncAlphaTest"] = 280] = "ZkSyncAlphaTest";
    ChainId[ChainId["MantleTest"] = 5001] = "MantleTest";
    ChainId[ChainId["MantleSepoliaTest"] = 5003] = "MantleSepoliaTest";
    ChainId[ChainId["ScrollTestL2"] = 534351] = "ScrollTestL2";
    ChainId[ChainId["LineaTest"] = 59140] = "LineaTest";
    ChainId[ChainId["OpsideTestRollux"] = 12008] = "OpsideTestRollux";
    ChainId[ChainId["MantaTest"] = 3441005] = "MantaTest";
    ChainId[ChainId["StagingFastActiveBellatrix"] = 1351057110] = "StagingFastActiveBellatrix";
    ChainId[ChainId["KromaSepoliaTest"] = 2358] = "KromaSepoliaTest";
    ChainId[ChainId["GasZeroGoerliL2"] = 12021] = "GasZeroGoerliL2";
    ChainId[ChainId["ZetaTest"] = 7001] = "ZetaTest";
    ChainId[ChainId["ZKFairTest"] = 43851] = "ZKFairTest";
    ChainId[ChainId["X1Test"] = 195] = "X1Test";
    ChainId[ChainId["MumbaiTest"] = 80001] = "MumbaiTest";
    ChainId[ChainId["TaikoHeklaL2Test"] = 167009] = "TaikoHeklaL2Test";
    ChainId[ChainId["TaikoKatlaL2Test"] = 167008] = "TaikoKatlaL2Test";
    ChainId[ChainId["MorphTest"] = 2710] = "MorphTest";
    ChainId[ChainId["BeraBArtioTest"] = 80084] = "BeraBArtioTest";
    ChainId[ChainId["BeraTest"] = 80085] = "BeraTest";
    ChainId[ChainId["MerlinTest"] = 686868] = "MerlinTest";
    ChainId[ChainId["BlastSepoliaTest"] = 168587773] = "BlastSepoliaTest";
    ChainId[ChainId["ZklinkNovaTest"] = 810182] = "ZklinkNovaTest";
    ChainId[ChainId["ModeSepoliaTest"] = 919] = "ModeSepoliaTest";
    ChainId[ChainId["AINNL2Test"] = 2648] = "AINNL2Test";
    ChainId[ChainId["FlowTest"] = 545] = "FlowTest";
    ChainId[ChainId["KakarotStarknetSepoliaTest"] = 920637907288165] = "KakarotStarknetSepoliaTest";
    ChainId[ChainId["MemeCoreTest"] = 43521] = "MemeCoreTest";
    ChainId[ChainId["TacTurinTest"] = 2390] = "TacTurinTest";
    ChainId[ChainId["DuckchainTestnet"] = 202105] = "DuckchainTestnet";
    ChainId[ChainId["MonadTest"] = 10143] = "MonadTest";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
const initialChains = [
    {
        id: ChainId.EthereumMainnet,
        name: 'Ethereum',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
            decimal: 18,
        },
        scanUrl: 'https://etherscan.io/',
        scanName: 'EtherScan',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.BSC,
        name: 'BNB-Chain',
        tokenSymbol: 'BNB',
        token: {
            symbol: 'BNB',
            address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WBNB',
        wrappedToken: {
            symbol: 'WBNB',
            address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
            decimal: 18,
        },
        scanUrl: 'https://bscscan.com/',
        scanName: 'BscScan',
        vmType: 'EVM',
        rpcUrl: 'https://bsc-dataseed.binance.org',
        blockDelta: 3,
        blockDeltaU: 3,
    },
    {
        id: ChainId.Aurora,
        name: 'Aurora Chain',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0xC9BdeEd33CD01541e1eeD10f90519d2C06Fe3feB',
            decimal: 18,
        },
        scanUrl: 'https://aurorascan.dev/',
        scanName: 'AuroraScan',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.aurora.dev',
        blockDelta: 1.5,
        blockDeltaU: 1.5,
    },
    {
        id: ChainId.Arbitrum,
        name: 'Arbitrum',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
            decimal: 18,
        },
        scanUrl: 'https://arbiscan.io/',
        scanName: 'ArbiScan',
        vmType: 'EVM',
        rpcUrl: 'https://arb1.arbitrum.io/rpc',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Matic,
        name: 'Polygon',
        tokenSymbol: 'Matic',
        token: {
            symbol: 'MATIC',
            address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WMATIC',
        wrappedToken: {
            symbol: 'WMATIC',
            address: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
            decimal: 18,
        },
        scanUrl: 'https://polygonscan.com/',
        scanName: 'PologonScan',
        vmType: 'EVM',
        rpcUrl: 'https://polygon-rpc.com/',
        blockDelta: 2,
        blockDeltaU: 2.2,
    },
    {
        id: ChainId.Cronos,
        name: 'Cronos',
        tokenSymbol: 'CRO',
        token: {
            symbol: 'CRO',
            address: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WCRO',
        wrappedToken: {
            symbol: 'WCRO',
            address: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23',
            decimal: 18,
        },
        scanUrl: 'https://cronoscan.com/',
        scanName: 'CronosScan',
        vmType: 'EVM',
        rpcUrl: 'https://node.croswap.com/rpc',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Optimism,
        name: 'Optimism',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x4200000000000000000000000000000000000006',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x4200000000000000000000000000000000000006',
            decimal: 18,
        },
        scanUrl: 'https://optimistic.etherscan.io/',
        scanName: 'OptimismScan',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.optimism.io',
    },
    {
        id: ChainId.ETC,
        name: 'Ethereum Classic',
        tokenSymbol: 'ETC',
        token: {
            symbol: 'ETC',
            address: '0x1953cab0E5bFa6D4a9BaD6E05fD46C1CC6527a5a',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETC',
        wrappedToken: {
            symbol: 'WETC',
            address: '0x1953cab0E5bFa6D4a9BaD6E05fD46C1CC6527a5a',
            decimal: 18,
        },
        scanUrl: 'https://blockscout.com/etc/mainnet/',
        scanName: 'EthereumClassicScan',
        vmType: 'EVM',
        rpcUrl: 'https://www.ethercluster.com/etc',
        blockDelta: 12.5,
        blockDeltaU: 14,
    },
    {
        id: ChainId.BSCTestnet,
        name: 'BSC Testnet',
        tokenSymbol: 'BNB',
        token: {
            symbol: 'BNB',
            address: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WBNB',
        wrappedToken: {
            symbol: 'WBNB',
            address: '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
            decimal: 18,
        },
        scanUrl: 'https://testnet.bscscan.com/',
        scanName: 'TestnetBscScan',
        vmType: 'EVM',
        rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
        blockDelta: 3,
        blockDeltaU: 3,
    },
    {
        id: ChainId.AuroraTestnet,
        name: 'Aurora Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
            decimal: 18,
        },
        scanUrl: 'https://testnet.aurorascan.dev/',
        scanName: 'TestnetAuroraScan',
        vmType: 'EVM',
        rpcUrl: 'https://testnet.aurora.dev',
        blockDelta: 1.5,
        blockDeltaU: 1.5,
    },
    {
        id: ChainId.Rinkeby,
        name: 'Rinkeby',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0xc778417E063141139Fce010982780140Aa0cD5Ab',
            decimal: 18,
        },
        scanUrl: 'https://rinkeby.etherscan.io/',
        scanName: 'EtherScan',
        vmType: 'EVM',
        rpcUrl: 'https://rinkeby.infura.io/v3/',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.ZkSyncAlphaTest,
        name: 'ZkSync Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x8C3e3f2983DB650727F3e05B7a7773e4D641537B',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x8C3e3f2983DB650727F3e05B7a7773e4D641537B',
            decimal: 18,
        },
        scanUrl: 'https://zksync2-testnet.zkscan.io/',
        scanName: 'zkSync scan',
        vmType: 'ZKVM',
        rpcUrl: 'https://zksync2-testnet.zksync.dev',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.ZkSyncEra,
        name: 'zkSync Era',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x5aea5775959fbc2557cc8789bc1bf90a239d9a91',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x5aea5775959fbc2557cc8789bc1bf90a239d9a91',
            decimal: 18,
        },
        scanUrl: 'https://explorer.zksync.io/',
        scanName: 'zkSync scan',
        vmType: 'ZKVM',
        rpcUrl: 'https://zksync2-mainnet.zksync.io',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.OntologyTestnet,
        name: 'Ontology Testnet',
        tokenSymbol: 'ONG',
        token: {
            symbol: 'ONG',
            address: '0xe8cf015f797877a9a23e80447429c0b0f04e114b',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WONG',
        wrappedToken: {
            symbol: 'WONG',
            address: '0xe8cf015f797877a9a23e80447429c0b0f04e114b',
            decimal: 18,
        },
        scanUrl: 'https://explorer.ont.io/testnet',
        scanName: 'ontology test scan',
        vmType: 'EVM',
        rpcUrl: 'https://polaris1.ont.io:10339',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Ontology,
        name: 'Ontology',
        tokenSymbol: 'ONG',
        token: {
            symbol: 'ONG',
            address: '0xd8bc24cfd45452ef2c8bc7618e32330b61f2691b',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WONG',
        wrappedToken: {
            symbol: 'WONG',
            address: '0xd8bc24cfd45452ef2c8bc7618e32330b61f2691b',
            decimal: 18,
        },
        scanUrl: 'https://explorer.ont.io/',
        scanName: 'ontology test scan',
        vmType: 'EVM',
        rpcUrl: 'https://dappnode1.ont.io:10339',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.MantleTest,
        name: 'Mantle Testnet',
        tokenSymbol: 'MNT',
        token: {
            symbol: 'MNT',
            address: '0x6e1723460D190B4A092a2c13BA42BcC57d71870b',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WMNT',
        wrappedToken: {
            symbol: 'WMNT',
            address: '0x6e1723460D190B4A092a2c13BA42BcC57d71870b',
            decimal: 18,
        },
        scanUrl: 'https://explorer.testnet.mantle.xyz',
        scanName: 'mantle test scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.testnet.mantle.xyz',
        blockDelta: 1,
        blockDeltaU: 1,
    },
    {
        id: ChainId.MantleSepoliaTest,
        name: 'Mantle Sepolia Testnet',
        tokenSymbol: 'MNT',
        token: {
            symbol: 'MNT',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WMNT',
        wrappedToken: {
            symbol: 'WMNT',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://explorer.sepolia.mantle.xyz/',
        scanName: 'mantle sepolia test explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.sepolia.mantle.xyz',
        blockDelta: 1,
        blockDeltaU: 1,
    },
    {
        id: ChainId.Mantle,
        name: 'Mantle',
        tokenSymbol: 'MNT',
        token: {
            symbol: 'MNT',
            address: '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WMNT',
        wrappedToken: {
            symbol: 'WMNT',
            address: '0x78c1b0C915c4FAA5FffA6CAbf0219DA63d7f4cb8',
            decimal: 18,
        },
        scanUrl: 'https://explorer.mantle.xyz/',
        scanName: 'mantle test scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.mantle.xyz',
        blockDelta: 1,
        blockDeltaU: 1,
    },
    {
        id: ChainId.ScrollTestL2,
        name: 'Scroll Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0xa1EA0B2354F5A344110af2b6AD68e75545009a03',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0xa1EA0B2354F5A344110af2b6AD68e75545009a03',
            decimal: 18,
        },
        scanUrl: 'https://sepolia-blockscout.scroll.io/',
        scanName: 'scroll sepolia test scan',
        vmType: 'EVM',
        rpcUrl: 'https://sepolia-rpc.scroll.io/',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Scroll,
        name: 'Scroll Mainnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x5300000000000000000000000000000000000004',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x5300000000000000000000000000000000000004',
            decimal: 18,
        },
        scanUrl: 'https://blockscout.scroll.io',
        scanName: 'scroll scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.scroll.io',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Icplaza,
        name: 'Icplaza',
        tokenSymbol: 'ICT',
        token: {
            symbol: 'ICT',
            address: '0xc59d478873d11CCc68F9c63571E821a253c5B605',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WICT',
        wrappedToken: {
            symbol: 'WICT',
            address: '0xc59d478873d11CCc68F9c63571E821a253c5B605',
            decimal: 18,
        },
        scanUrl: 'https://browsemainnet.ic-plaza.org/index/',
        scanName: 'icplaza scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpcmainnet.ic-plaza.org/',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.ConfluxESpace,
        name: 'Conflux',
        tokenSymbol: 'CFX',
        token: {
            symbol: 'CFX',
            address: '0x14b2d3bc65e74dae1030eafd8ac30c533c976a9b',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WCFX',
        wrappedToken: {
            symbol: 'WCFX',
            address: '0x14b2d3bc65e74dae1030eafd8ac30c533c976a9b',
            decimal: 18,
        },
        scanUrl: 'https://evm.confluxscan.net',
        scanName: 'conflux espace scan',
        vmType: 'EVM',
        rpcUrl: 'https://evm.confluxrpc.com',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Meter,
        name: 'Meter',
        tokenSymbol: 'MTR',
        token: {
            symbol: 'MTR',
            address: '0x160361ce13ec33C993b5cCA8f62B6864943eb083',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WMTR',
        wrappedToken: {
            symbol: 'WMTR',
            address: '0x160361ce13ec33C993b5cCA8f62B6864943eb083',
            decimal: 18,
        },
        scanUrl: 'https://scan.meter.io',
        scanName: 'meter scan',
        vmType: 'EVM',
        rpcUrl: 'https://pokt.network',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Telos,
        name: 'Telos',
        tokenSymbol: 'TLOS',
        token: {
            symbol: 'TLOS',
            address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WTLOS',
        wrappedToken: {
            symbol: 'WTLOS',
            address: '0xD102cE6A4dB07D247fcc28F366A623Df0938CA9E',
            decimal: 18,
        },
        scanUrl: 'https://www.teloscan.io/',
        scanName: 'telo scan',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.telos.net/evm',
        blockDelta: 12,
        blockDeltaU: 12,
    },
    {
        id: ChainId.Goerli,
        name: 'Goerli',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0xb4fbf271143f4fbf7b91a5ded31805e42b2208d6',
            decimal: 18,
        },
        scanUrl: 'https://goerli.etherscan.io/',
        scanName: 'goerliScan',
        vmType: 'EVM',
        rpcUrl: 'https://goerli.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
        blockDelta: 14,
        blockDeltaU: 14,
    },
    {
        id: ChainId.MaticTestnet,
        name: 'Polygon Mumbai Testnet',
        tokenSymbol: 'Matic',
        token: {
            symbol: 'Matic',
            address: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WMatic',
        wrappedToken: {
            symbol: 'WMatic',
            address: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
            decimal: 18,
        },
        scanUrl: 'https://mumbai.polygonscan.com/',
        scanName: 'PolygonMumbaiScan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc-mumbai.maticvigil.com',
    },
    {
        id: ChainId.Ultron,
        name: 'Ultron',
        tokenSymbol: 'ULX',
        token: {
            symbol: 'ULX',
            address: '0xb1183357745D3fD7d291E42a2c4B478cdB5710c6',
            decimal: 18,
        },
        wrappedTokenSymbol: 'wULX',
        wrappedToken: {
            symbol: 'wULX',
            address: '0xb1183357745D3fD7d291E42a2c4B478cdB5710c6',
            decimal: 18,
        },
        scanUrl: 'https://ulxscan.com',
        scanName: 'UltronScan',
        vmType: 'EVM',
        rpcUrl: 'https://ultron-rpc.net',
    },
    {
        id: ChainId.OpsideTestRollux,
        name: 'Opside Public zkEVM Testnet',
        tokenSymbol: 'IDE',
        token: {
            symbol: 'IDE',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WIDE',
        wrappedToken: {
            symbol: 'WIDE',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://public.zkevm.opside.info',
        scanName: 'Opside Rollux Testnet Explorer',
        vmType: 'zkEVM',
        rpcUrl: 'https://pre-alpha-zkrollup-rpc.opside.network/public',
    },
    {
        id: ChainId.Base,
        name: 'Base',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x4200000000000000000000000000000000000006',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x4200000000000000000000000000000000000006',
            decimal: 18,
        },
        scanUrl: 'https://basescan.org/',
        scanName: 'base scan',
        vmType: 'EVM',
        rpcUrl: 'https://developer-access-mainnet.base.org',
    },
    {
        id: ChainId.LineaTest,
        name: 'Linea Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
            decimal: 18,
        },
        scanUrl: 'https://explorer.goerli.linea.build/',
        scanName: 'Linea Testnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.goerli.linea.build/',
    },
    {
        id: ChainId.Linea,
        name: 'Linea',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0xe5D7C2a44FfDDf6b295A15c148167daaAf5Cf34f',
            decimal: 18,
        },
        scanUrl: 'https://lineascan.build/',
        scanName: 'Linea Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.infura.io/v3/',
    },
    {
        id: ChainId.Loot,
        name: 'Lootchain',
        tokenSymbol: 'AGLD',
        token: {
            symbol: 'AGLD',
            address: '0x7a524c7e82874226F0b51aade60A1BE4D430Cf0F',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WAGLD',
        wrappedToken: {
            symbol: 'WAGLD',
            address: '0x7a524c7e82874226F0b51aade60A1BE4D430Cf0F',
            decimal: 18,
        },
        scanUrl: 'https://explorer.lootchain.com/',
        scanName: 'Loot Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.lootchain.com/http',
    },
    {
        id: ChainId.StagingFastActiveBellatrix,
        name: 'Skale Testnet',
        tokenSymbol: 'sFUEL',
        token: {
            symbol: 'sFUEL',
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
            decimal: 18,
        },
        wrappedTokenSymbol: 'wsFUEL',
        wrappedToken: {
            symbol: 'wsFUEL',
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
            decimal: 18,
        },
        scanUrl: 'https://staging-fast-active-bellatrix.explorer.staging-v3.skalenodes.com/',
        scanName: 'staging-fast-active-bellatrix scan',
        vmType: 'EVM',
        rpcUrl: 'https://staging-v3.skalenodes.com/v1/staging-fast-active-bellatrix/',
    },
    {
        id: ChainId.KromaSepoliaTest,
        name: 'Kroma Sepolia Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x4200000000000000000000000000000000000001',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x4200000000000000000000000000000000000001',
            decimal: 18,
        },
        scanUrl: 'https://blockscout.sepolia.kroma.network/',
        scanName: 'Kroma Sepolia Testnet Blockscout',
        vmType: 'EVM',
        rpcUrl: 'https://api.sepolia.kroma.network/',
    },
    {
        id: ChainId.Kroma,
        name: 'Kroma',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x4200000000000000000000000000000000000001',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x4200000000000000000000000000000000000001',
            decimal: 18,
        },
        scanUrl: 'https://blockscout.kroma.network/',
        scanName: 'Kroma Mainnet Blockscout',
        vmType: 'EVM',
        rpcUrl: 'https://api.kroma.network/',
    },
    {
        id: ChainId.Manta,
        name: 'Manta Pacific',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            address: '0x0Dc808adcE2099A9F62AA87D9670745AbA741746',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            address: '0x0Dc808adcE2099A9F62AA87D9670745AbA741746',
            decimal: 18,
        },
        scanUrl: 'https://manta-pacific.calderaexplorer.xyz/',
        scanName: 'manta scan',
        vmType: 'EVM',
        rpcUrl: 'https://manta-pacific.calderachain.xyz/http',
    },
    {
        id: ChainId.OpBNB,
        name: 'OpBNB',
        tokenSymbol: 'BNB',
        token: {
            symbol: 'BNB',
            address: '0x4200000000000000000000000000000000000006',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WBNB',
        wrappedToken: {
            symbol: 'WBNB',
            address: '0x4200000000000000000000000000000000000006',
            decimal: 18,
        },
        scanUrl: 'https://mainnet.opbnbscan.com/',
        scanName: 'OpBNB Mainnet scan',
        vmType: 'EVM',
        rpcUrl: 'https://opbnb-mainnet-rpc.bnbchain.org/',
    },
    {
        id: ChainId.GasZeroGoerliL2,
        name: 'GasZeroGoerliL2',
        tokenSymbol: 'GAS0',
        token: {
            symbol: 'GAS0',
            address: '0xC6C7c2edF70A3245ad6051E93809162B9758ce08',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WGAS0',
        wrappedToken: {
            symbol: 'GAS0',
            address: '0xC6C7c2edF70A3245ad6051E93809162B9758ce08',
            decimal: 18,
        },
        scanUrl: 'https://scangoerlitest.gaszero.com/',
        scanName: 'GasZero GoerliL2 scan',
        vmType: 'EVM',
        rpcUrl: 'https://goerlitest.gaszero.com/',
    },
    {
        id: ChainId.ZetaTest,
        name: 'Zeta Testnet',
        tokenSymbol: 'aZETA',
        token: {
            symbol: 'aZETA',
            address: '0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf',
            decimal: 18,
        },
        wrappedTokenSymbol: 'WZETA',
        wrappedToken: {
            symbol: 'WZETA',
            address: '0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf',
            decimal: 18,
        },
        scanUrl: 'https://zetachain-athens-3.blockscout.com/',
        scanName: 'zeta testnet scan',
        vmType: 'EVM',
        rpcUrl: 'https://zetachain-athens-evm.blockpi.network/v1/rpc/public/',
    },
    {
        id: ChainId.Zeta,
        name: 'Zeta Mainnet',
        tokenSymbol: 'ZETA',
        token: {
            symbol: 'ZETA',
            decimal: 18,
            address: '0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf',
        },
        wrappedTokenSymbol: 'WZETA',
        wrappedToken: {
            symbol: 'WZETA',
            decimal: 18,
            address: '0x5F0b1a82749cb4E2278EC87F8BF6B618dC71a8bf',
        },
        scanUrl: 'https://zetachain.blockscout.com/',
        scanName: 'zeta blockscout',
        vmType: 'EVM',
        rpcUrl: 'https://zetachain-evm.blockpi.network/v1/rpc/public/',
    },
    {
        id: ChainId.X1Test,
        name: 'X1 Testnet',
        tokenSymbol: 'OKB',
        token: {
            symbol: 'OKB',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WOKB',
        wrappedToken: {
            symbol: 'WOKB',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://www.oklink.com/x1-test/',
        scanName: 'x1 testnet',
        vmType: 'EVM',
        rpcUrl: 'https://testrpc.x1.tech/',
    },
    {
        id: ChainId.ZKFairTest,
        name: 'zkfair Testnet',
        tokenSymbol: 'USDC',
        token: {
            symbol: 'USDC',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WUSDC',
        wrappedToken: {
            symbol: 'WUSDC',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://testnet-scan.zkfair.io',
        scanName: 'zkfair testnet',
        vmType: 'EVM',
        rpcUrl: 'https://testnet-rpc.zkfair.io/',
    },
    {
        id: ChainId.ZKFair,
        name: 'ZKFair',
        tokenSymbol: 'USDC',
        token: {
            symbol: 'USDC',
            decimal: 18,
            address: '0xD33Db7EC50A98164cC865dfaa64666906d79319C',
        },
        wrappedTokenSymbol: 'WUSDC',
        wrappedToken: {
            symbol: 'WUSDC',
            decimal: 18,
            address: '0xD33Db7EC50A98164cC865dfaa64666906d79319C',
        },
        scanUrl: 'https://scan.zkfair.io',
        scanName: 'ZKFair mainnet explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.zkfair.io',
    },
    {
        id: ChainId.MumbaiTest,
        name: 'MumbaiTest',
        tokenSymbol: 'MATIC',
        token: {
            symbol: 'MATIC',
            decimal: 18,
            address: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
        },
        wrappedTokenSymbol: 'WMATIC',
        wrappedToken: {
            symbol: 'WMATIC',
            decimal: 18,
            address: '0x9c3c9283d3e44854697cd22d3faa240cfb032889',
        },
        scanUrl: 'https://mumbai.polygonscan.com/',
        scanName: 'Mumbai testnet scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc-mumbai.maticvigil.com',
    },
    {
        id: ChainId.TaikoKatlaL2Test,
        name: 'Taiko Katla L2 testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0xC6C7c2edF70A3245ad6051E93809162B9758ce08',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0xC6C7c2edF70A3245ad6051E93809162B9758ce08',
        },
        scanUrl: 'https://explorer.katla.taiko.xyz/',
        scanName: 'taiko katla test l2 explore',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.katla.taiko.xyz',
    },
    {
        id: ChainId.Taiko,
        name: 'Taiko',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0xA51894664A773981C6C112C43ce576f315d5b1B6',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0xA51894664A773981C6C112C43ce576f315d5b1B6',
        },
        scanUrl: 'https://taikoscan.network',
        scanName: 'taiko scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.mainnet.taiko.xyz',
    },
    {
        id: ChainId.TaikoHeklaL2Test,
        name: 'Taiko Hekla L2 testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://explorer.hekla.taiko.xyz/',
        scanName: 'taiko hekla test l2 explore',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.hekla.taiko.xyz',
    },
    {
        id: ChainId.MorphTest,
        name: 'Morph testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0xC6C7c2edF70A3245ad6051E93809162B9758ce08',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0xC6C7c2edF70A3245ad6051E93809162B9758ce08',
        },
        scanUrl: 'https://explorer-testnet.morphl2.io/',
        scanName: 'morph testnet explore',
        vmType: 'EVM',
        rpcUrl: 'https://rpc-testnet.morphl2.io',
    },
    {
        id: ChainId.BeraBArtioTest,
        name: 'Bera bArtio testnet',
        tokenSymbol: 'BERA',
        token: {
            symbol: 'BERA',
            decimal: 18,
            address: '0x7507c1dc16935B82698e4C63f2746A2fCf994dF8',
        },
        wrappedTokenSymbol: 'WBERA',
        wrappedToken: {
            symbol: 'WBERA',
            decimal: 18,
            address: '0x7507c1dc16935B82698e4C63f2746A2fCf994dF8',
        },
        scanUrl: 'https://bartio.beratrail.io/',
        scanName: 'bera BArtio testnet explore',
        vmType: 'EVM',
        rpcUrl: 'https://bartio.rpc.berachain.com/',
    },
    {
        id: ChainId.BeraTest,
        name: 'Bera testnet',
        tokenSymbol: 'BERA',
        token: {
            symbol: 'BERA',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WBERA',
        wrappedToken: {
            symbol: 'WBERA',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://artio.beratrail.io/',
        scanName: 'bera testnet explore',
        vmType: 'EVM',
        rpcUrl: 'https://artio.rpc.berachain.com/',
    },
    {
        id: ChainId.Merlin,
        name: 'Merlin',
        tokenSymbol: 'BTC',
        token: {
            symbol: 'BTC',
            decimal: 18,
            address: '0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA',
        },
        wrappedTokenSymbol: 'WBTC',
        wrappedToken: {
            symbol: 'WBTC',
            decimal: 18,
            address: '0xF6D226f9Dc15d9bB51182815b320D3fBE324e1bA',
        },
        scanUrl: 'https://scan.merlinchain.io/',
        scanName: 'merlin explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.merlinchain.io/',
    },
    {
        id: ChainId.MerlinTest,
        name: 'Merlin Testnet',
        tokenSymbol: 'BTC',
        token: {
            symbol: 'BTC',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WBTC',
        wrappedToken: {
            symbol: 'WBTC',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://testnet-scan.merlinchain.io/',
        scanName: 'merlin testnet explorer',
        vmType: 'EVM',
        rpcUrl: 'https://testnet-rpc.merlinchain.io',
    },
    {
        id: ChainId.BlastSepoliaTest,
        name: 'Blast Sepolia Test',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000023',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000023',
        },
        scanUrl: 'https://testnet.blastscan.io',
        scanName: 'blast sepolia testnet scan',
        vmType: 'EVM',
        rpcUrl: 'https://sepolia.blast.io',
    },
    {
        id: ChainId.Blast,
        name: 'Blast',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x4300000000000000000000000000000000000004',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x4300000000000000000000000000000000000004',
        },
        scanUrl: 'https://blastscan.io',
        scanName: 'blast scan',
        vmType: 'EVM',
        rpcUrl: 'https://blast.blockpi.network/v1/rpc/public',
    },
    {
        id: ChainId.Blast,
        name: 'Blast',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x4300000000000000000000000000000000000004',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x4300000000000000000000000000000000000004',
        },
        scanUrl: 'https://blastscan.io',
        scanName: 'Blast scan',
        vmType: 'EVM',
        rpcUrl: 'https://blast.blockpi.network/v1/rpc/public',
    },
    {
        id: ChainId.ZklinkNova,
        name: 'zkLink Nova',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x8280a4e7D5B3B658ec4580d3Bc30f5e50454F169',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x8280a4e7D5B3B658ec4580d3Bc30f5e50454F169',
        },
        scanUrl: 'https://explorer.zklink.io',
        scanName: 'Zklink Nova mainnet explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.zklink.io',
    },
    {
        id: ChainId.Mode,
        name: 'Mode',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000006',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000006',
        },
        scanUrl: 'https://explorer.mode.network/',
        scanName: 'Mode Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.mode.network/',
    },
    {
        id: ChainId.AINNL2Test,
        name: 'AINN L2 Testnet',
        tokenSymbol: 'BTC',
        token: {
            symbol: 'BTC',
            decimal: 18,
            address: '0xa9754f0D9055d14EB0D2d196E4C51d8B2Ee6f4d3',
        },
        wrappedTokenSymbol: 'WBTC',
        wrappedToken: {
            symbol: 'WBTC',
            decimal: 18,
            address: '0xa9754f0D9055d14EB0D2d196E4C51d8B2Ee6f4d3',
        },
        scanUrl: 'https://explorer.anvm.io/',
        scanName: 'AINN Layer2 Testnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.anvm.io/',
    },
    {
        id: ChainId.AINNL2,
        name: 'AILayer',
        tokenSymbol: 'BTC',
        token: {
            symbol: 'BTC',
            decimal: 18,
            address: '0x1470a4831F76954686BfB4dE8180F7469EA8dE6F',
        },
        wrappedTokenSymbol: 'ABTC',
        wrappedToken: {
            symbol: 'ABTC',
            decimal: 18,
            address: '0x1470a4831F76954686BfB4dE8180F7469EA8dE6F',
        },
        scanUrl: 'https://mainnet-explorer.anvm.io/',
        scanName: 'AINN Layer2 Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet-rpc.anvm.io/',
    },
    {
        id: ChainId.XLayer,
        name: 'X Layer',
        tokenSymbol: 'OKB',
        token: {
            symbol: 'OKB',
            decimal: 18,
            address: '0xe538905cf8410324e03a5a23c1c177a474d59b2b',
        },
        wrappedTokenSymbol: 'WOKB',
        wrappedToken: {
            symbol: 'WOKB',
            decimal: 18,
            address: '0xe538905cf8410324e03a5a23c1c177a474d59b2b',
        },
        scanUrl: 'https://www.okx.com/explorer/xlayer/',
        scanName: 'XLayer Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://xlayerrpc.okx.com/',
    },
    {
        id: ChainId.ZklinkNovaTest,
        name: 'Zklink Nova testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0xAec84500e96F90370C55657d08f375A8d05F4D8c',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0xAec84500e96F90370C55657d08f375A8d05F4D8c',
        },
        scanUrl: 'https://goerli.explorer.zklink.io',
        scanName: 'Zklink Nova testnet scan',
        vmType: 'EVM',
        rpcUrl: 'https://goerli.rpc.zklink.io',
    },
    {
        id: ChainId.ModeSepoliaTest,
        name: 'Mode Sepolia Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0xeb72756ee12309Eae82a0deb9787e69f5b62949c',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0xeb72756ee12309Eae82a0deb9787e69f5b62949c',
        },
        scanUrl: 'https://sepolia.explorer.mode.network/',
        scanName: 'Mode Sepolia Testnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://sepolia.mode.network',
    },
    {
        id: ChainId.KakarotStarknetSepoliaTest,
        name: 'Kakarot Starknet Sepolia Testnet',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x67A1f4A939b477A6b7c5BF94D97E45dE87E608eF',
        },
        scanUrl: 'https://sepolia.kakarotscan.org/',
        scanName: 'Kakarot Starknet Sepolia Testnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://sepolia-rpc.kakarot.org',
    },
    {
        id: ChainId.BOB,
        name: 'BOB',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000006',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000006',
        },
        scanUrl: 'https://explorer.gobob.xyz/',
        scanName: 'BOB Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.gobob.xyz/',
    },
    {
        id: ChainId.Cyber,
        name: 'Cyber',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000006',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x4200000000000000000000000000000000000006',
        },
        scanUrl: 'https://cyber-explorer.alt.technology/',
        scanName: 'Cyber Chain Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://cyber.alt.technology/',
    },
    {
        id: ChainId.Klaytn,
        name: 'Klaytn',
        tokenSymbol: 'KLAY',
        token: {
            symbol: 'KLAY',
            decimal: 18,
            address: '0x19Aac5f612f524B754CA7e7c41cbFa2E981A4432',
        },
        wrappedTokenSymbol: 'WKLAY',
        wrappedToken: {
            symbol: 'WKLAY',
            decimal: 18,
            address: '0x19Aac5f612f524B754CA7e7c41cbFa2E981A4432',
        },
        scanUrl: 'https://klaytnscope.com/',
        scanName: 'Klaytn Chain Mainnet Scope',
        vmType: 'EVM',
        rpcUrl: 'https://klaytn.drpc.org',
    },
    {
        id: ChainId.Kava,
        name: 'Kava',
        tokenSymbol: 'KAVA',
        token: {
            symbol: 'KAVA',
            decimal: 18,
            address: '0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b',
        },
        wrappedTokenSymbol: 'WKAVA',
        wrappedToken: {
            symbol: 'WKAVA',
            decimal: 18,
            address: '0xc86c7C0eFbd6A49B35E8714C5f59D99De09A225b',
        },
        scanUrl: 'https://www.oklink.com/zh-hans/kava/',
        scanName: 'Kava Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://evm.kava-rpc.com',
    },
    {
        id: ChainId.Core,
        name: 'Core',
        tokenSymbol: 'CORE',
        token: {
            symbol: 'CORE',
            decimal: 18,
            address: '0x40375c92d9faf44d2f9db9bd9ba41a3317a2404f',
        },
        wrappedTokenSymbol: 'WCORE',
        wrappedToken: {
            symbol: 'WCORE',
            decimal: 18,
            address: '0x40375c92d9faf44d2f9db9bd9ba41a3317a2404f',
        },
        scanUrl: 'https://scan.coredao.org/',
        scanName: 'Core Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://core.public.infstones.com',
    },
    {
        id: ChainId.RootStock,
        name: 'RootStock',
        tokenSymbol: 'RBTC',
        token: {
            symbol: 'RBTC',
            decimal: 18,
            address: '0x542fda317318ebf1d3deaf76e0b632741a7e677d',
        },
        wrappedTokenSymbol: 'WRBTC',
        wrappedToken: {
            symbol: 'WRBTC',
            decimal: 18,
            address: '0x542fda317318ebf1d3deaf76e0b632741a7e677d',
        },
        scanUrl: 'https://explorer.rootstock.io/',
        scanName: 'RootStock Mainnet Explore',
        vmType: 'EVM',
        rpcUrl: 'https://public-node.rsk.co',
    },
    {
        id: ChainId.MAP,
        name: 'MAP',
        tokenSymbol: 'MAPO',
        token: {
            symbol: 'MAPO',
            decimal: 18,
            address: '0x13cb04d4a5dfb6398fc5ab005a6c84337256ee23',
        },
        wrappedTokenSymbol: 'WMAP',
        wrappedToken: {
            symbol: 'WMAP',
            decimal: 18,
            address: '0x13cb04d4a5dfb6398fc5ab005a6c84337256ee23',
        },
        scanUrl: 'https://maposcan.io/',
        scanName: 'Map Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.maplabs.io',
    },
    {
        id: ChainId.NEON,
        name: 'NEON',
        tokenSymbol: 'NEON',
        token: {
            symbol: 'NEON',
            decimal: 18,
            address: '0x202c35e517fa803b537565c40f0a6965d7204609',
        },
        wrappedTokenSymbol: 'WNEON',
        wrappedToken: {
            symbol: 'WNEON',
            decimal: 18,
            address: '0x202c35e517fa803b537565c40f0a6965d7204609',
        },
        scanUrl: 'https://neonscan.org/',
        scanName: 'Neon Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://neon-proxy-mainnet.solana.p2p.org',
    },
    {
        id: ChainId.Gravity,
        name: 'Gravity',
        tokenSymbol: 'G',
        token: {
            symbol: 'G',
            decimal: 18,
            address: '0xBB859E225ac8Fb6BE1C7e38D87b767e95Fef0EbD',
        },
        wrappedTokenSymbol: 'wG',
        wrappedToken: {
            symbol: 'wG',
            decimal: 18,
            address: '0xBB859E225ac8Fb6BE1C7e38D87b767e95Fef0EbD',
        },
        scanUrl: 'https://explorer.gravity.xyz',
        scanName: 'Gravity Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.gravity.xyz',
    },
    {
        id: ChainId.Iotex,
        name: 'IoTeX',
        tokenSymbol: 'IOTX',
        token: {
            symbol: 'IOTX',
            decimal: 18,
            address: '0xa00744882684c3e4747faefd68d283ea44099d03',
        },
        wrappedTokenSymbol: 'WIOTX',
        wrappedToken: {
            symbol: 'WIOTX',
            decimal: 18,
            address: '0xa00744882684c3e4747faefd68d283ea44099d03',
        },
        scanUrl: 'https://iotexscan.io/',
        scanName: 'Iotex Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://babel-api.fastblocks.io',
    },
    {
        id: ChainId.Morph,
        name: 'Morph',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x5300000000000000000000000000000000000011',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x5300000000000000000000000000000000000011',
        },
        scanUrl: 'https://explorer.morphl2.io/',
        scanName: 'Morph Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.morphl2.io',
    },
    {
        id: ChainId.FlowTest,
        name: 'Flow Testnet',
        tokenSymbol: 'FLOW',
        token: {
            symbol: 'FLOW',
            decimal: 18,
            address: '0x1eE5eDC5Fe498a2dD82862746D674DB2a5e7fef6',
        },
        wrappedTokenSymbol: 'WFLOW',
        wrappedToken: {
            symbol: 'WFLOW',
            decimal: 18,
            address: '0x1eE5eDC5Fe498a2dD82862746D674DB2a5e7fef6',
        },
        scanUrl: 'https://evm-testnet.flowscan.io',
        scanName: 'Flow Testnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://testnet.evm.nodes.onflow.org',
    },
    {
        id: ChainId.Flow,
        name: 'Flow',
        tokenSymbol: 'FLOW',
        token: {
            symbol: 'FLOW',
            decimal: 18,
            address: '0xd3bF53DAC106A0290B0483EcBC89d40FcC961f3e',
        },
        wrappedTokenSymbol: 'WFLOW',
        wrappedToken: {
            symbol: 'WFLOW',
            decimal: 18,
            address: '0xd3bF53DAC106A0290B0483EcBC89d40FcC961f3e',
        },
        scanUrl: 'https://evm.flowscan.io/',
        scanName: 'Flow Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.evm.nodes.onflow.org',
    },
    {
        id: ChainId.MemeCoreTest,
        name: 'MemeCore Testnet',
        tokenSymbol: 'M',
        token: {
            symbol: 'M',
            decimal: 18,
            address: '0x1eE5eDC5Fe498a2dD82862746D674DB2a5e7fef6',
        },
        wrappedTokenSymbol: 'WM',
        wrappedToken: {
            symbol: 'WM',
            decimal: 18,
            address: '0x1eE5eDC5Fe498a2dD82862746D674DB2a5e7fef6',
        },
        scanUrl: 'https://formicarium.memecorescan.io/',
        scanName: 'MemeCore Testnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.formicarium.memecore.net',
    },
    {
        id: ChainId.TacTurinTest,
        name: 'Tac Turin Testnet',
        tokenSymbol: 'TAC',
        token: {
            symbol: 'TAC',
            decimal: 18,
            address: '0x876508837C162aCedcc5dd7721015E83cbb4e339',
        },
        wrappedTokenSymbol: 'WTAC',
        wrappedToken: {
            symbol: 'WTAC',
            decimal: 18,
            address: '0x876508837C162aCedcc5dd7721015E83cbb4e339',
        },
        scanUrl: 'https://turin.explorer.tac.build/',
        scanName: 'Tac Turin Testnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://turin.rpc.tac.build',
    },
    {
        id: ChainId.Plume,
        name: 'Plume',
        tokenSymbol: 'ETH',
        token: {
            symbol: 'ETH',
            decimal: 18,
            address: '0x626613B473F7eF65747967017C11225436EFaEd7',
        },
        wrappedTokenSymbol: 'WETH',
        wrappedToken: {
            symbol: 'WETH',
            decimal: 18,
            address: '0x626613B473F7eF65747967017C11225436EFaEd7',
        },
        scanUrl: 'https://explorer.plumenetwork.xyz/',
        scanName: 'Plume Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.plumenetwork.xyz',
    },
    {
        id: ChainId.MonadTest,
        name: 'Monad Testnet',
        tokenSymbol: 'MON',
        token: {
            symbol: 'MON',
            decimal: 18,
            address: '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701',
        },
        wrappedTokenSymbol: 'WMON',
        wrappedToken: {
            symbol: 'WMON',
            decimal: 18,
            address: '0x760AfE86e5de5fa0Ee542fc7B7B713e1c5425701',
        },
        scanUrl: 'https://explorer.monad-testnet.category.xyz/',
        scanName: 'Monad Testnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.monad-testnet.category.xyz/rpc/SPa4TbSgMJxz5ywmzYvvc9O5nkAVGTgOcsi7yErG',
    },
    {
        id: ChainId.HashKey,
        name: 'HashKey',
        tokenSymbol: 'HSK',
        token: {
            symbol: 'HSK',
            decimal: 18,
            address: '0xB210D2120d57b758EE163cFfb43e73728c471Cf1',
        },
        wrappedTokenSymbol: 'WHSK',
        wrappedToken: {
            symbol: 'WHSK',
            decimal: 18,
            address: '0xB210D2120d57b758EE163cFfb43e73728c471Cf1',
        },
        scanUrl: 'https://hashkey.blockscout.com/',
        scanName: 'HashKey Mainnet Explorer',
        vmType: 'EVM',
        rpcUrl: 'https://mainnet.hsk.xyz',
    },
    {
        id: ChainId.DuckchainTestnet,
        name: 'DuchChain Testnet',
        tokenSymbol: 'TON',
        token: {
            symbol: 'TON',
            decimal: 18,
            address: '0x1eE5eDC5Fe498a2dD82862746D674DB2a5e7fef6',
        },
        wrappedTokenSymbol: 'WTON',
        wrappedToken: {
            symbol: 'WTON',
            decimal: 18,
            address: '0x1eE5eDC5Fe498a2dD82862746D674DB2a5e7fef6',
        },
        scanUrl: 'https://testnet-scan.duckchain.io/',
        scanName: 'Duckchain Testnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://testnet-rpc.duckchain.io',
    },
    {
        id: ChainId.Duckchain,
        name: 'DuckChain',
        tokenSymbol: 'TON',
        token: {
            symbol: 'TON',
            decimal: 18,
            address: '0x7F9308E8d724e724EC31395f3af52e0593BB2e3f',
        },
        wrappedTokenSymbol: 'WTON',
        wrappedToken: {
            symbol: 'WTON',
            decimal: 18,
            address: '0x7F9308E8d724e724EC31395f3af52e0593BB2e3f',
        },
        scanUrl: 'https://scan.duckchain.io/',
        scanName: 'Duckchain Mainnet Scan',
        vmType: 'EVM',
        rpcUrl: 'https://rpc.duckchain.io',
    },
];
const lookupTableReducer = (table, next, index) => {
    table[next.id] = initialChains[index];
    return table;
};
exports.initialChainTable = initialChains.reduce(lookupTableReducer, {});
const getChain = (chainId) => {
    return exports.initialChainTable[chainId];
};
exports.getChain = getChain;
var PointRoundingType;
(function (PointRoundingType) {
    PointRoundingType[PointRoundingType["POINT_ROUNDING_NEAREST"] = 0] = "POINT_ROUNDING_NEAREST";
    PointRoundingType[PointRoundingType["POINT_ROUNDING_UP"] = 1] = "POINT_ROUNDING_UP";
    PointRoundingType[PointRoundingType["POINT_ROUNDING_DOWN"] = 2] = "POINT_ROUNDING_DOWN";
})(PointRoundingType = exports.PointRoundingType || (exports.PointRoundingType = {}));
var PriceRoundingType;
(function (PriceRoundingType) {
    PriceRoundingType[PriceRoundingType["PRICE_ROUNDING_NEAREST"] = 0] = "PRICE_ROUNDING_NEAREST";
    PriceRoundingType[PriceRoundingType["PRICE_ROUNDING_UP"] = 1] = "PRICE_ROUNDING_UP";
    PriceRoundingType[PriceRoundingType["PRICE_ROUNDING_DOWN"] = 2] = "PRICE_ROUNDING_DOWN";
})(PriceRoundingType = exports.PriceRoundingType || (exports.PriceRoundingType = {}));
exports.CHAIN_EIP1559_SET = new Set([
    ChainId.EthereumMainnet,
    ChainId.Rinkeby,
]);
const buildSendingParams = (chain, params, gasPrice) => {
    if (exports.CHAIN_EIP1559_SET.has(chain.id)) {
        return params;
    }
    const newParams = Object.assign({}, params);
    if (newParams.maxFeePerGas !== undefined) {
        newParams.gasPrice = newParams.maxFeePerGas;
        delete newParams.maxFeePerGas;
    }
    else {
        newParams.gasPrice = gasPrice;
    }
    // todo: support transform from maxPriorityFeePerGas to maxFeePerGas
    if (newParams.maxPriorityFeePerGas !== undefined) {
        delete newParams.maxPriorityFeePerGas;
    }
    return newParams;
};
exports.buildSendingParams = buildSendingParams;
